import { useState } from 'react';
import { useGroupChannel } from '@sendbird/uikit-react/GroupChannel/context';
import { MenuItem, MessageMenu, useMessageMenuContext } from '@sendbird/uikit-react/ui/MessageMenu';
import Dialog from '@components/common/modal/Dialog';
import * as S from '@styles/chat/chat.style';
import { IconCornerDownRight, IconSpeakerphone, IconEdit, IconTrash } from '@tabler/icons-react';
import { useUserInfoQuery } from '@apis/query/user';
import { UserType } from '@asset/enum/UserEnum';
import { ChatMessageMenu, ChatMessageType } from '@asset/enum/chatEnum';
import { useChatStore } from '@store/chat';
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const CustomMessageMenuButton = ({
  menuProps,
  channelInputRef
}) => {
  const {
    data: user
  } = useUserInfoQuery();
  const {
    message,
    isByMe
  } = menuProps;
  const isFileMessage = message.isFileMessage() || message.isMultipleFilesMessage();
  const isRepliedMessage = message.parentMessageId !== 0;
  const menuItems = [];
  if (!isRepliedMessage && message.customType !== ChatMessageType.QUESTION) {
    menuItems.push(ChatMessageMenu.REPLY);
  }
  if (user?.type === UserType.TEACHER && !isFileMessage && message.customType !== ChatMessageType.QUESTION) {
    menuItems.push(ChatMessageMenu.ANNOUNCE);
  }
  if (isByMe) {
    if (!isFileMessage && message.customType !== ChatMessageType.QUESTION) {
      menuItems.push(ChatMessageMenu.EDIT);
    }
    menuItems.push(ChatMessageMenu.DELETE);
  }
  if (menuItems.length === 0) return /*#__PURE__*/_jsx(_Fragment, {});
  return /*#__PURE__*/_jsx(S.ChatMessageMenuButton, {
    children: /*#__PURE__*/_jsx(MessageMenu, {
      ...menuProps,
      renderMenuItems: props => {
        const {
          EditMenuItem
        } = props.items;
        const messageMenuMap = {
          [ChatMessageMenu.REPLY]: /*#__PURE__*/_jsx(CustomReplyMenuItem, {
            channelInputRef: channelInputRef,
            menuProps: menuProps
          }),
          [ChatMessageMenu.ANNOUNCE]: /*#__PURE__*/_jsx(CustomAnnounceMenuItem, {
            menuProps: menuProps
          }),
          [ChatMessageMenu.EDIT]: /*#__PURE__*/_jsxs(EditMenuItem, {
            children: [/*#__PURE__*/_jsx(IconEdit, {
              size: 16,
              color: "var(--gray-10)"
            }), "\uC218\uC815"]
          }),
          [ChatMessageMenu.DELETE]: /*#__PURE__*/_jsx(CustomDeleteMenuItem, {})
        };
        return /*#__PURE__*/_jsx(_Fragment, {
          children: menuItems.map(menuItem => messageMenuMap[menuItem])
        });
      }
    })
  });
};
export default CustomMessageMenuButton;
const CustomReplyMenuItem = ({
  channelInputRef,
  menuProps
}) => {
  const {
    message
  } = menuProps;
  const {
    setClickedMessageToReply
  } = useChatStore();
  const {
    hideMenu
  } = useMessageMenuContext();
  return /*#__PURE__*/_jsxs(MenuItem, {
    onClick: () => {
      channelInputRef.current.focus();
      setClickedMessageToReply(message);
      hideMenu();
    },
    children: [/*#__PURE__*/_jsx(IconCornerDownRight, {
      size: 16,
      color: 'var(--gray-10)'
    }), "\uB2F5\uC7A5"]
  });
};
const CustomAnnounceMenuItem = ({
  menuProps
}) => {
  const {
    message,
    channel
  } = menuProps;
  const {
    hideMenu
  } = useMessageMenuContext();
  const handleCreateNotification = async () => {
    try {
      await channel.pinMessage(message.messageId);
      channel.pinnedMessageIds.map(prevPinnedMessageId => {
        if (prevPinnedMessageId !== message.messageId) channel.unpinMessage(prevPinnedMessageId);
      });
    } catch (error) {
      console.error('Error pinning message:', error);
    }
  };
  return /*#__PURE__*/_jsxs(MenuItem, {
    onClick: () => {
      handleCreateNotification();
      hideMenu();
    },
    children: [/*#__PURE__*/_jsx(IconSpeakerphone, {
      size: 16,
      color: "var(--gray-10)"
    }), "\uACF5\uC9C0"]
  });
};
const CustomDeleteMenuItem = () => {
  const {
    actions: {
      deleteMessage
    }
  } = useGroupChannel();
  const {
    message,
    hideMenu,
    disableDeleteMessage
  } = useMessageMenuContext();
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const disableDeleteMenu = typeof disableDeleteMessage === 'boolean' ? disableDeleteMessage : (message.threadInfo?.replyCount ?? 0) > 0;
  if (!disableDeleteMenu) {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs(MenuItem, {
        onClick: () => setOpenDeleteModal(true),
        children: [/*#__PURE__*/_jsx(IconTrash, {
          size: 16,
          color: "var(--gray-10)"
        }), "\uC0AD\uC81C"]
      }), openDeleteModal && /*#__PURE__*/_jsx(Dialog, {
        title: '메시지 삭제',
        content: ['메시지를 삭제할까요?', '다른 사람의 화면에서도 메시지가 삭제됩니다.'],
        buttons: [{
          variant: 'Outline',
          text: '취소',
          onClick: () => {
            setOpenDeleteModal(false);
            hideMenu();
          }
        }, {
          variant: 'Destructive',
          text: '삭제',
          onClick: () => deleteMessage(message)
        }]
      })]
    });
  }
};